import "reflect-metadata";
import App from "App";
import { ContextProvider } from "context/AuthenticationContext";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./assets/styles/global.scss";
import * as serviceWorker from "./serviceWorker";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }} key={"main-root"}>
    <ContextProvider>
      <App />
    </ContextProvider>
  </Router>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
